import script from "./BusinessCardFields.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessCardFields.vue?vue&type=script&setup=true&lang=js"

import "./BusinessCardFields.vue?vue&type=style&index=0&id=ed3e88e6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed3e88e6"]])

export default __exports__